require('./brokerMarketsCalendarEvents.scss');

const PropTypes = require('prop-types');

const React = require('react');
const { FormattedText } = require('core/i18n').i18n;

// @helpers
const { taggingEventHandled } = require('utilities/taggingEventHandled');

class BrokerMarketsCalendarEvents extends React.Component {
    buildEventLists() {
        const {
            events,
            max
        } = this.props;

        return events.slice(0, max).map((immEvent, index) => {
            const transformToOrdinal = {
                [0]: 'first',
                [1]: 'second',
                [2]: 'third',
                [3]: 'fourth',
                [4]: 'fifth'
            }   
            return (
                <article key={immEvent.get('id')} className="broker-markets-calendar-events__list">
                    <p className="broker-markets-calendar-events__time">
                        {immEvent.get('time')}
                    </p>
                    <h4 
                        className="broker-markets-calendar-events__title"
                        onClick={() => index !== undefined && taggingEventHandled(this.props.pageName, `agendaCard`, transformToOrdinal[index])}
                    >
                        {immEvent.get('title')}
                    </h4>
                    <FormattedText
                        value="broker-marketsCalendarEventsInfo"
                        injectedStrings={[immEvent.get('estimation'), immEvent.get('previousData')]}
                        className="broker-markets-calendar-events__estimation"
                    />
                </article>
            );
        });
    }

    render() {
        const eventLists = this.buildEventLists()
        return (
            <section className="broker-markets-calendar-events">
                {eventLists}
            </section>
        );
    }
}

BrokerMarketsCalendarEvents.propTypes = {
    events: PropTypes.object.isRequired,
    max: PropTypes.number.isRequired,
    pageName: PropTypes.string
}

module.exports = BrokerMarketsCalendarEvents;
